<script>
export { render as render };
export { staticRenderFns as staticRenderFns };
var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "navbar-container d-flex content align-items-center" },
    [
      _c("ul", { staticClass: "nav navbar-nav d-xl-none" }, [
        _c(
          "li",
          { staticClass: "nav-item" },
          [
            _c(
              "b-link",
              {
                staticClass: "nav-link",
                on: { click: _vm.toggleVerticalMenuActive },
              },
              [_c("feather-icon", { attrs: { icon: "MenuIcon", size: "21" } })],
              1
            ),
          ],
          1
        ),
      ]),
      _c(
        "div",
        {
          staticClass:
            "bookmark-wrapper align-items-center flex-grow-1 d-none d-lg-flex",
        },
        [_c("dark-Toggler", { staticClass: "d-none d-lg-block" })],
        1
      ),
      _c(
        "b-navbar-nav",
        { staticClass: "nav align-items-center ml-auto" },
        [
          _c("locale"),
          _c(
            "b-nav-item-dropdown",
            {
              staticClass: "dropdown-user",
              attrs: {
                right: "",
                "toggle-class": "d-flex align-items-center dropdown-user-link",
              },
              scopedSlots: _vm._u([
                {
                  key: "button-content",
                  fn: function () {
                    return [
                      _c("b-avatar", {
                        staticClass: "badge-minimal",
                        attrs: {
                          size: "40",
                          variant: "light-primary",
                          badge: "",
                          text: _vm.firstName,
                          "badge-variant": "success",
                        },
                      }),
                    ]
                  },
                  proxy: true,
                },
              ]),
            },
            [
              _c(
                "b-dropdown-item",
                {
                  attrs: {
                    to: { name: "profile" },
                    "link-class": "d-flex align-items-center",
                  },
                },
                [
                  _c("feather-icon", {
                    staticClass: "mr-50",
                    attrs: { size: "20", icon: "UserIcon" },
                  }),
                  _c("span", [_vm._v(_vm._s(_vm.$t("profile.Profile")))]),
                ],
                1
              ),
              _c(
                "b-dropdown-item",
                {
                  attrs: {
                    to: { name: "set-new-password" },
                    "link-class": "d-flex align-items-center",
                  },
                },
                [
                  _c("feather-icon", {
                    staticClass: "mr-50",
                    attrs: { size: "20", icon: "LockIcon" },
                  }),
                  _c("span", [
                    _vm._v(_vm._s(_vm.$t("profile.ChangePassword"))),
                  ]),
                ],
                1
              ),
              _c("b-dropdown-divider"),
              _c(
                "b-dropdown-item",
                {
                  attrs: { "link-class": "d-flex align-items-center" },
                  on: { click: _vm.logout },
                },
                [
                  _c("feather-icon", {
                    staticClass: "mr-50",
                    attrs: { size: "16", icon: "LogOutIcon" },
                  }),
                  _c("span", [_vm._v(_vm._s(_vm.$t("Logout")))]),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c("ResendVerifyLink", {
        attrs: {
          resendEmail: _vm.resendEmail,
          toggleResendEmailPop: _vm.toggleResendEmailPop,
        },
      }),
      _c("StoreCountryCode", {
        attrs: {
          showPop: _vm.isShowCountryPop,
          onModalHidden: _vm.onModalHidden,
        },
      }),
      _c("Set2FA", { attrs: { modalVisible: _vm.isModalVisible } }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true



//# sourceURL=webpack:///./src/layouts/components/Navbar.vue?./node_modules/cache-loader/dist/cjs.js?%7B%22cacheDirectory%22:%22node_modules/.cache/vue-loader%22,%22cacheIdentifier%22:%229dcd27b4-vue-loader-template%22%7D!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options

import * as bootstrapvue from 'bootstrap-vue';
import core_layouts_components_app_navbar_components_DarkToggler_vue from '@core/layouts/components/app-navbar/components/DarkToggler.vue';
import Locale_vue from './Locale.vue';
import NotificationDropdown_vue from './NotificationDropdown.vue';
import * as vuex from 'vuex';
import core_components_toastification_ToastificationContent_vue from '@core/components/toastification/ToastificationContent.vue';
import libs_api_api from '@/libs/api/api';
import ResendVerifyLink_vue from './ResendVerifyLink.vue';
import StoreCountryCode_vue from './StoreCountryCode.vue';
import Set2FA_vue from './Set2FA.vue';
import auth_jwt_useJwt from '@/auth/jwt/useJwt';
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//












export default ({
  render,
  staticRenderFns,
  components: {
    BLink: bootstrapvue["BLink"],
    BNavbarNav: bootstrapvue["BNavbarNav"],
    BNavItemDropdown: bootstrapvue["BNavItemDropdown"],
    BDropdownItem: bootstrapvue["BDropdownItem"],
    BDropdownDivider: bootstrapvue["BDropdownDivider"],
    BAvatar: bootstrapvue["BAvatar"],
    Locale: Locale_vue,
    NotificationDropdown: NotificationDropdown_vue,
    DarkToggler: core_layouts_components_app_navbar_components_DarkToggler_vue,
    BButton: bootstrapvue["BButton"],
    ResendVerifyLink: ResendVerifyLink_vue,
    Set2FA: Set2FA_vue,
    StoreCountryCode: StoreCountryCode_vue
  },
  data() {
    return {
      resendEmail: false,
      isLoading: false,
      firstName: "",
      isModalVisible: false,
      isShowCountryPop: false
    };
  },
  props: {
    toggleVerticalMenuActive: {
      type: Function,
      default: () => {}
    }
  },
  async created() {
    this.fetchCoin();

    // this.userInfo();
    const userInfo = JSON.parse(localStorage.getItem("userInfo"));
    if (userInfo) {
      var _userInfo$email;
      this.firstName = ((_userInfo$email = userInfo.email) === null || _userInfo$email === void 0 ? void 0 : _userInfo$email[0]) || "";
      if (!userInfo.emailVerified) {
        //  show pop
        await this.userInfo();
      } else {
        // hide pop
        await this.userInfo();
        this.resendEmail = false;
        if (!userInfo.totpLinked) {
          const shown2faAlready = JSON.parse(localStorage.getItem("showed2fa"));
          if (shown2faAlready !== "true") {
            this.toggleModal();
            localStorage.setItem("showed2fa", JSON.stringify("true"));
          }
        }
      }
    }
  },
  computed: {
    ...vuex.mapState("user", ["user"])
  },
  methods: {
    ...vuex.mapMutations("user", ["setKycRefData", "setUser", "setCoins", "setRefData"]),
    onModalHidden(flag) {
      this.isShowCountryPop = flag;
      if (!flag) {
        this.userInfo();
      }
    },
    toggleResendEmailPop(props) {
      this.resendEmail = props;
    },
    toggleModal() {
      this.isModalVisible = !this.isModalVisible;
    },
    async userInfo() {
      try {
        const res = await new libs_api_api().api({
          method: "GET",
          url: `auth/user/info`
        }, {}, {
          isLoading: true
        });
        if (res && res.userInfo && !res.userInfo.emailVerified) {
          this.resendEmail = true;
          localStorage.setItem("userInfo", JSON.stringify(res.userInfo));
          this.setUser(res.userInfo);
        } else if (res && res.userInfo && res.userInfo.emailVerified) {
          this.resendEmail = false;
          this.setUser(res.userInfo);
          localStorage.setItem("userInfo", JSON.stringify(res.userInfo));
        }
        if (!this.resendEmail && res && res.userInfo && !res.userInfo.countryCode) {
          this.onModalHidden(true);
        } else if (res && res.userInfo && res.userInfo.countryCode) {
          await this.getRefData(res.userInfo.countryCode);
        }
        if (res && res.error && res.error.message) {
          this.$toast({
            component: core_components_toastification_ToastificationContent_vue,
            props: {
              title: res.error.message,
              icon: "EditIcon",
              variant: "danger"
            }
          });
        }
      } catch (error) {
        this.$toast({
          component: core_components_toastification_ToastificationContent_vue,
          props: {
            title: error,
            icon: "EditIcon",
            variant: "danger"
          }
        });
      }
    },
    async getKYCRefData(countryCode) {
      try {
        this.isLoading = true;
        const res = await new libs_api_api().api({
          method: "GET",
          url: `kyc/refdata/${countryCode}`
        }, {}, {});
        if (res && res.refData) {
          this.setKycRefData(res.refData);
        } else if (res && res.error && res.error.message) {
          this.$toast({
            component: core_components_toastification_ToastificationContent_vue,
            props: {
              title: res.error.message,
              icon: "EditIcon",
              variant: "danger"
            }
          });
        }
      } catch (error) {
        this.$toast({
          component: core_components_toastification_ToastificationContent_vue,
          props: {
            title: error,
            icon: "EditIcon",
            variant: "danger"
          }
        });
      }
      this.isLoading = false;
    },
    async getRefData(countryCode) {
      try {
        this.isLoading = true;
        const res = await new libs_api_api().api({
          method: "GET",
          url: `p2p/refdata/${countryCode}`
        }, {}, {});
        if (res) {
          this.setRefData(res);
        } else if (res && res.error && res.error.message) {
          this.$toast({
            component: core_components_toastification_ToastificationContent_vue,
            props: {
              title: res.error.message,
              icon: "EditIcon",
              variant: "danger"
            }
          });
        }
      } catch (error) {
        this.$toast({
          component: core_components_toastification_ToastificationContent_vue,
          props: {
            title: error,
            icon: "EditIcon",
            variant: "danger"
          }
        });
      }
      this.isLoading = false;
    },
    async fetchCoin() {
      try {
        this.isLoading = true;
        const res = await new libs_api_api().api({
          method: "GET",
          url: `p2p/coins`
        }, {}, {});
        if (res && res.coins) {
          this.setCoins(res.coins);
        } else if (res && res.error && res.error.message) {
          this.$toast({
            component: core_components_toastification_ToastificationContent_vue,
            props: {
              title: res.error.message,
              icon: "EditIcon",
              variant: "danger"
            }
          });
        }
      } catch (error) {
        this.$toast({
          component: core_components_toastification_ToastificationContent_vue,
          props: {
            title: error,
            icon: "EditIcon",
            variant: "danger"
          }
        });
      }
      this.isLoading = false;
    },
    async logout() {
      localStorage.removeItem(auth_jwt_useJwt.jwtConfig.storageTokenKeyName);
      localStorage.removeItem(auth_jwt_useJwt.jwtConfig.storageRefreshTokenKeyName);
      localStorage.removeItem("userInfo");
      localStorage.removeItem("showed2fa");
      this.$router.push({
        name: "auth-login",
        params: {
          lang: this.lang || undefined
        }
      });
    }
  }
});

//# sourceURL=webpack:///./src/layouts/components/Navbar.vue?./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options
</script>

